import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { reminderAnalysesActions } from 'features/reminderAnalyses';

const useReminderAnalyses = () => {
  const dispatch = useDispatch();
  const getReminderAnalyses = useCallback(({ offset }) => dispatch(reminderAnalysesActions.getReminderAnalyses({ offset })), [dispatch]);
  const getReminderAnalysis = useCallback(({ id, cable }) => dispatch(reminderAnalysesActions.getReminderAnalysis({ id, cable })), [dispatch]);
  const clearLocalReminderAnalyses = useCallback(() => dispatch(reminderAnalysesActions.clearLocalReminderAnalyses()), [dispatch]);
  const clearLocalActiveReminderAnalysis = useCallback(() => dispatch(reminderAnalysesActions.clearLocalActiveReminderAnalysis()), [dispatch]);

  return {
    getReminderAnalyses,
    getReminderAnalysis,
    clearLocalReminderAnalyses,
    clearLocalActiveReminderAnalysis
  };
};

export default useReminderAnalyses;